import type { PageLoad } from './$types';

export const load: PageLoad = () => {
  return {
    meta: {
      title: 'Reports',
      activeNav: 'reports',
      breadcrumbs: {
        activeTitle: 'Reports',
        items: [],
      },
    },
  };
};
